import React from 'react';
import Styles from './styles.module.css';
import DefaultTitle from '../title';
import DefaultDesc from '../desc';

type DefaultSelect1Props = {
  error: boolean,
  title: string,
  list: string[],
  value: string,
  setValue: (value: string) => void;
  hint?: any;
  setHintText?: (value: string) => void;
  desc?: string,
};

const DefaultSelect1: React.FC<DefaultSelect1Props> = ({ error, title, list, hint, setHintText, value, desc, setValue}) => {

  return (
    <>
    <DefaultTitle
      title={title}
      hint={hint}
      setHintText={setHintText}
    />
    <select className={Styles.select} style={error ? { border: ".5px solid #E31C5F", color: "#E31C5F" } : {}} value={value} onChange={(e) => setValue(e.target.value)}>
      {list.map((data, index) =>
        <option value={data === '未選択' ? '' : data} key={index}>{data}</option>
      )}
    </select>
    {desc && ( <DefaultDesc text={desc} /> )}
    </>
  );
}

export default DefaultSelect1;
